import { render } from "./kumo1.vue?vue&type=template&id=2e4187d7&scoped=true"
import script from "./kumo1.vue?vue&type=script&lang=js"
export * from "./kumo1.vue?vue&type=script&lang=js"

import "./kumo1.vue?vue&type=style&index=0&id=2e4187d7&scoped=true&lang=css"

import exportComponent from "/Users/atomu/Desktop/GitHub/good_neet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e4187d7"]])

export default __exports__